(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('emailProfileSecurityStack', ["path", "$q", "fileSecurityDebugHelper", "widgetPolling", "sizeClasses", "fileDao", "defaultListConverter", "troubleshooting", "widgetSettings", "entityTypes", "modals", "$rootScope", "solgateExceptionsParams", "apExceptionsModal", "urlReputationWhitelistLinksModalRun", function (path, $q, fileSecurityDebugHelper, widgetPolling, sizeClasses, fileDao, defaultListConverter, troubleshooting, widgetSettings, entityTypes, modals, $rootScope, solgateExceptionsParams, apExceptionsModal, urlReputationWhitelistLinksModalRun) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/common/email-security-stack').template('email-security-stack'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                var entityType = widgetPolling.scope().entityType;
                $scope.troubleshooting = troubleshooting.entityDebugEnabled();
                $scope.updateTick = 60000;
                $scope.getSizeClasses = sizeClasses;
                $scope.scanDetailsLoading = true;
                $scope.cpCapsuleInfoLoading = true;
                $scope.attachmentsStatusLoading = true;
                $scope.attachmentsStatusLoaded = false;
                $scope.attachmentsWidgetTitle = 'Found malicious attachment';
                $scope.attachmentsStatus = {
                    'class': 'file-security-stack-table vertical-middle',
                    columns: [
                        {
                            id: 'entity_id',
                            hidden: true,
                            primary: true
                        },
                        {
                            id: 'ContentType',
                            text: false,
                            converter: 'mimeIconConverter',
                            converterArgs: { niceMimeColumn: 'nice_mime_type' },
                            dataStyle: { width: '40px' },
                            style: { width: '40px' }
                        },
                        {
                            id: 'Name',
                            text: 'Name',
                            href: {
                                type: 'file',
                                params: { id: 'entity_id' }
                            },
                            dataClass: 'file-security-attachment-name'
                        },
                        {
                            id: 'finding',
                            converter: 'multiListConverter',
                            converterArgs: {
                                countPostfix: 'activities',
                                collapseRest: true,
                                expanded: 4,
                                uniqueCountText: 'times',
                                uniqueTrim: true,
                                elementAsTooltip: true,
                                'class': 'max-width-300'
                            },
                            dataClass: 'file-security-finding-column'
                        },
                        {
                            id: 'exceptionLinks',
                            hidden: true
                        },
                        {
                            id: 'reportLinks',
                            hidden: true
                        },
                        {
                            id: 'scanStatus',
                            text: ' ',
                            dataClass: 'file-security-status-icon',
                            converter: 'attachmentScanStatusConverter'
                        }
                    ]
                };
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    // get scan-details
                    fileDao.allScanDetails(id, entityType, null, widgetPolling.scope().objectTypes).then(function (response) {
                        $scope.scanDetailsLoading = false;
                        $scope.scanDetails = response.data;
                    });
                    // get capsule info
                    fileDao.cpCapsuleInfo(id, entityType).then(function (response) {
                        var cpCapsuleInfo = response.data;
                        var cryptPair;
                        if (cpCapsuleInfo) {
                            if (cpCapsuleInfo.encryptedEntities && cpCapsuleInfo.encryptedEntities.length) {
                                cryptPair = {
                                    type: 'encrypted',
                                    pair_entity_id: cpCapsuleInfo.encryptedEntities[0].entity_id
                                };
                            } else if (cpCapsuleInfo.orig_file_id) {
                                cryptPair = {
                                    type: 'original',
                                    pair_entity_id: cpCapsuleInfo.orig_file_id
                                };
                            }
                        }
                        $scope.cpCapsuleInfoLoading = false;
                        if (cryptPair) {
                            $scope.cpCapsuleInfo = {
                                wrapper: {
                                    class: 'file-security-stack-category',
                                    title: 'Encryption',
                                    type: 'widget-panel'
                                },
                                type: 'info',
                                lines: [{
                                        text: '#' + JSON.stringify({
                                            display: 'link',
                                            text: 'View ' + cryptPair.type + ' file',
                                            type: 'file',
                                            id: cryptPair.pair_entity_id,
                                            class: 'crypt-pair-link'
                                        })
                                    }]
                            };
                        }
                    });
                    return $q.when();
                };
                $scope.buttons = [];
                $scope.filters = {
                    uuid: '96d4b3f1-f171-45a3-8437-dd349c1159d3',
                    forceUpdate: function () {
                        $scope.loadData();
                    },
                    // this filter is available for debug mode only.
                    // troubleshooting.entityDebugEnabled() is true
                    filters: []
                };
                if (troubleshooting.entityDebugEnabled()) {
                    var params = widgetSettings.params($scope.filters.uuid);
                    var troubleshootingEnabled = troubleshooting.enabled();
                    if (params.troubleshooting !== troubleshootingEnabled) {
                        params.troubleshooting = troubleshootingEnabled;
                        widgetSettings.params($scope.filters.uuid, params);
                    }
                    $scope.buttons.push({
                        id: 'raw-info-sec-entities',
                        label: 'Full Info (sec_entities)',
                        'class': 'btn-blue',
                        execute: function () {
                            return fileSecurityDebugHelper.showSecEntities(id, entityType);
                        },
                        position: 'right'
                    });
                    $scope.filters.filters.push({
                        type: 'flag',
                        text: 'Troubleshooting Mode',
                        value: 'troubleshooting',
                        local: true
                    });
                }
                // removed download this email feature, moved to email-info widget
                // get attachments status
                $scope.$watch(function () {
                    return widgetPolling.scope().insecureAttachments;
                }, function (insecureAttachments) {
                    if (!insecureAttachments || !insecureAttachments.rows || !insecureAttachments.rows.length) {
                        $scope.attachmentsStatus.data = [];
                        $scope.attachmentsStatusLoading = false;
                        $scope.attachmentsStatusLoaded = false;
                        return;
                    }
                    if (insecureAttachments.columns) {
                        $scope.attachmentsStatus.columns = insecureAttachments.columns;
                    }
                    if (insecureAttachments.rows[0].scanStatus && insecureAttachments.rows[0].scanStatus.indexOf('DLP') !== -1) {
                        $scope.attachmentsWidgetTitle = 'Found sensitive attachment';
                    }
                    defaultListConverter({ data: { rows: insecureAttachments.rows } }, {
                        columns: $scope.attachmentsStatus.columns,
                        mimeIcons: insecureAttachments.mimeIcons,
                        converters: {
                            'attachmentScanStatusConverter': function (text, columnId, columnsMap, args, converters) {
                                try {
                                    var data = JSON.parse(text.slice(1));
                                    data.tooltip.position.my = 'bottom right';
                                    if (data.display === 'text' && args && args.href && converters._makeLinkParams) {
                                        var linkParams = converters._makeLinkParams(columnsMap, args.href);
                                        if (linkParams) {
                                            $.extend(true, data, linkParams);
                                        }
                                    }
                                    return '#' + JSON.stringify(data);
                                } catch (e) {
                                    return text;
                                }
                            }
                        }
                    }).then(function (response) {
                        $scope.attachmentsStatus.data = response.data.data;
                        $scope.attachmentsStatusLoading = false;
                        $scope.attachmentsStatusLoaded = true;
                    });
                });
                // reloadListener
                $scope.$on('file-security-stack-reload', function () {
                    $scope.scanDetailsLoading = true;
                    $scope.loadData();
                });
                // secToolExceptionListener
                $scope.$on('add-sec-tool-exception', function (event, data) {
                    var localEntity = entityTypes.toLocal(entityType);
                    modals.confirm({
                        message: 'Are you sure you want to add this ' + (localEntity === 'email' ? 'message' : localEntity) + ' to ' + secToolsExceptionParams.getLabel(data.secType) + '?',
                        title: 'Add Security Tools Exception',
                        okText: 'Add exception'
                    }).then(function () {
                        return fileDao.exceptionsAdd([{
                                entity_type: data.entityType,
                                entity_id: data.entityId,
                                sec_type: data.secType
                            }]);
                    }).then(function () {
                        $rootScope.$broadcast('file-security-stack-reload');
                    });
                });
                // solgateExceptionListener
                $scope.$on('add-solgate-exception', function (event, data) {
                    return solgateExceptionsParams.addDialog(data.macro_hash).then(function () {
                        $rootScope.$broadcast('file-security-stack-reload');
                    });
                });
                // avananApExeceptionsListener
                $scope.$on('add-avanan-ap-exception', function (event, data) {
                    return apExceptionsModal.show({
                        entityType: data.entityType,
                        entityId: data.entityId,
                        scanStatus: data.scanStatus,
                        type: 'whitelist'
                    }).then(function () {
                        $rootScope.$broadcast('file-security-stack-reload');
                    });
                });
                // apAvananBlacklistListener
                $scope.$on('add-ap-avanan-blacklist', function (event, data) {
                    return apExceptionsModal.show({
                        entityType: data.entityType,
                        entityId: data.entityId,
                        scanStatus: data.scanStatus,
                        type: 'blacklist'
                    }).then(function () {
                        $rootScope.$broadcast('file-security-stack-reload');
                    });
                });
                // whitelistURLsListener
                $scope.$on('open-whitelist-links-modal', function (event, data) {
                    return urlReputationWhitelistLinksModalRun.show(data).then(function () {
                    });
                });
                // paramsWatch
                $scope.$watch(function () {
                    return widgetSettings.params($scope.filters.uuid);
                }, function (newValue, oldValue) {
                    if (troubleshooting.entityDebugEnabled()) {
                        troubleshooting.enabled(widgetSettings.params($scope.filters.uuid).troubleshooting);
                    }
                    if (!_(newValue).isEqual(oldValue)) {
                        $scope.scanDetailsLoading = true;
                    }
                    $scope.loadData();
                }, true);
            }
        };
    }]);
}());